// extracted by mini-css-extract-plugin
module.exports = {"grid":"GridComponent_grid__kaysv"};